import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api, formatINR, statusClass } from '../utils/api';
import { VendorFormModal } from './Vendors';

export default function VendorProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vendor,  setVendor]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [showEdit,setShowEdit]= useState(false);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/vendors/${id}`).then(d => { setVendor(d); setLoading(false); }).catch(() => setLoading(false));
  }, [id]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="loading-state">Loading…</div>;
  if (!vendor)  return <div className="empty-state">Vendor not found.</div>;

  return (
    <div className="page-content">
      <div className="topbar">
        <div className="breadcrumb">
          <span style={{cursor:'pointer',color:'var(--red)'}} onClick={() => navigate('/vendors')}>Vendors</span>
          <span> / {vendor.name}</span>
        </div>
        <div className="topbar-right">
          <button className="btn btn-outline" onClick={() => setShowEdit(true)}>✎ Edit Vendor</button>
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
        <div className="card card-body">
          <div style={{fontSize:16,fontWeight:700,color:'var(--text-dark)',marginBottom:10}}>{vendor.name}</div>
          {[['Service Type', vendor.service_type],['Phone', vendor.phone],['Email', vendor.email],
            ['GSTIN', vendor.gstin],['PAN', vendor.pan],['Bank Account', vendor.bank_account],
            ['IFSC', vendor.ifsc],['Bank Name', vendor.bank_name]
          ].map(([label, val]) => val ? (
            <div key={label} style={{display:'flex',gap:12,marginBottom:5,fontSize:12}}>
              <span style={{color:'var(--text-light)',minWidth:110}}>{label}</span>
              <span style={{color:'var(--text-dark)',fontWeight:500}}>{val}</span>
            </div>
          ) : null)}
          {vendor.notes && <div style={{marginTop:8,fontSize:11,color:'var(--text-light)',background:'var(--bg-subtle)',padding:'8px 10px',borderRadius:5}}>{vendor.notes}</div>}
        </div>

        <div className="card card-body" style={{display:'flex',flexDirection:'column',gap:8}}>
          <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:'var(--text-light)',marginBottom:4}}>Financial Summary</div>
          {[
            ['Total Budgeted',    formatINR(vendor.assignments?.reduce((s,a)=>s+a.budgeted_cost,0)||0), 'var(--text-dark)'],
            ['Total Paid',        formatINR(vendor.assignments?.reduce((s,a)=>s+a.paid,0)||0), 'var(--success)'],
            ['Total Outstanding', formatINR(vendor.assignments?.reduce((s,a)=>s+a.outstanding,0)||0), 'var(--danger)'],
          ].map(([label, val, color]) => (
            <div key={label} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'5px 0',borderBottom:'1px solid var(--border-light)'}}>
              <span style={{color:'var(--text-light)'}}>{label}</span>
              <span style={{fontWeight:700,color}}>{val}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title">Project Assignments</span></div>
        {!vendor.assignments?.length ? (
          <div className="empty-state"><div className="empty-state-icon">📁</div>No project assignments.</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr>
                <th>Project</th><th>Client</th><th>Line Item</th><th>Status</th>
                <th className="num">Budgeted</th><th className="num">Paid</th><th className="num">Outstanding</th>
              </tr></thead>
              <tbody>
                {vendor.assignments.map(a => (
                  <tr key={a.id} onClick={() => navigate(`/projects/${a.project_id}`)}>
                    <td style={{fontWeight:600,color:'var(--text-dark)'}}>{a.project_name}</td>
                    <td style={{fontSize:11,color:'var(--text-light)'}}>{a.client_name}</td>
                    <td style={{fontSize:11}}>{a.line_item_name}</td>
                    <td><span className={`badge ${statusClass(a.status)}`}>{a.status}</span></td>
                    <td className="num">{formatINR(a.budgeted_cost)}</td>
                    <td className="num" style={{color:'var(--success)',fontWeight:600}}>{formatINR(a.paid)}</td>
                    <td className="num" style={{color:a.outstanding>0?'var(--danger)':'var(--success)',fontWeight:700}}>{formatINR(a.outstanding)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showEdit && <VendorFormModal vendor={vendor} onClose={() => setShowEdit(false)} onSaved={() => { setShowEdit(false); load(); }} />}
    </div>
  );
}
